<template>
  <div class="lyric_search">
    <div class="othen_search">
      <div class="date_search">
        <div class="time">
          <el-row>
            <el-col :md="24" :lg="5">
              <div class="item_title date_item">Select Time:</div>
            </el-col>
            <el-col :md="24" :lg="19" v-if="!isMyDate">
              <el-date-picker
                @blur="getStartDate"
                type="date"
                value-format="yyyy-MM-dd"
                :picker-options="pickerOptionsStart"
                placeholder="Start date"
                v-model="startDate"
              ></el-date-picker>
              <span class="to_txt">&nbsp;&nbsp;to&nbsp;&nbsp;</span>
              <el-date-picker
                @blur="getEndDate"
                type="date"
                value-format="yyyy-MM-dd"
                :picker-options="pickerOptionsEnd"
                placeholder="End date"
                v-model="endDate"
              ></el-date-picker>
            </el-col>
            <el-col :md="24" :lg="19" v-else>
              <DatePicker
                :startTime="startDate"
                :endTime="endDate"
                @startConfirm="startConfirm"
                @endConfirm="endConfirm"
                @startCancel="startCancel"
                @endCancel="endCancel"
                @startClear="startClear"
                @endClear="endClear"
              ></DatePicker>
            </el-col>
          </el-row>
        </div>
      </div>
      <div class="news_source">
        <div class="item_title">News Source:</div>
        <el-select
          v-model="newsVal"
          clearable
          placeholder="Source site"
          :popper-append-to-body="false"
          @change="handleSelect"
        >
          <el-option v-for="(item,i) in options" :key="i" :label="item.label" :value="item.value"></el-option>
        </el-select>
      </div>
      <!-- 新闻搜索 -->
      <div class="search">
        <el-input placeholder="Search Keywords" v-model="searchVal" class="input_style">
          <el-button @click="search" slot="append" icon="el-icon-search"></el-button>
        </el-input>
      </div>
    </div>
    <div class="data_list" v-if="newsData&&newsData.length>0">
      <div
        class="infinite-list"
        v-infinite-scroll="load"
        infinite-scroll-disabled="disabled"
        infinite-scroll-distance="10"
        infinite-scroll-delay="400"
      >
        <div class="news" v-for="(item,index) of newsData" :key="index">
          <div class="news_img">
            <div class="img_container">
              <img :src="item.cover" @error="defaultImg(item)" />
            </div>
          </div>
          <div class="news_content">
            <!-- 点击标题跳转详情 -->
            <div
              class="title text_one_lines"
              @click="newContentDetail(item.id)"
              v-html="item.title"
            >{{item.title}}</div>
            <div class="detail text_two_line" v-html="item.summary">{{item.summary}}</div>
            <div class="other_infor">
              <div class="new_from">
                <span class="item_title">Source:</span>
                <span class="item_detail color_alone">
                  {{item.source}}
                  <el-divider direction="vertical"></el-divider>
                </span>
              </div>
              <div class="new_author" v-if="item.author !== null">
                <span class="item_title">Author:</span>
                <span class="item_detail">
                  {{item.author}}
                  <el-divider direction="vertical"></el-divider>
                </span>
              </div>
              <div class="new_time">
                <span class="item_title">Updated:</span>
                <span class="item_detail">{{item.publish}}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 分页  -->
      <!-- <el-pagination
        background
        layout="prev, pager, next"
        :total="totalNum"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-size="pageSize"
      ></el-pagination>-->
    </div>
    <div v-else>
      <div class="no_data">
        <img :src="noDataImgUrl" alt />
        <div class="no_data_txt">No search results yet</div>
      </div>
    </div>
  </div>
</template>

<script>
import { overseasPublic, newsID } from "@/common/js/http/version3Api.js";
import qs from "qs";
import { contentCompany } from "@/common/js/http/version3Api.js";
import DatePicker from "../mobile/DatePickerLocal";

export default {
  name: "LyricSearch",
  props: ["companyIfor"],
  components: {
    DatePicker
  },
  data() {
    return {
      isMyDate: false,
      restaurants: [],
      state1: "",
      currentPage: 1,
      pageSize: 10,
      totalNum: 0, //总页数为100
      entryKeyword: false,
      entryNews: false,
      entryStart: false,
      entryEnd: false,
      companyID: this.$route.query.id,
      searchVal: "",
      newsVal: "",
      startDate: "",
      endDate: "",
      options: [],
      loading: false,
      totalPage: 0,
      otherData: {
        imgAndTxt: []
      },
      pickerOptionsStart: {
        disabledDate: time => {
          let endDateVal = this.endDate;
          if (endDateVal) {
            return time.getTime() > new Date(endDateVal).getTime();
          }
        }
      },
      pickerOptionsEnd: {
        disabledDate: time => {
          let beginDateVal = this.startDate;
          if (beginDateVal) {
            return time.getTime() < new Date(beginDateVal).getTime();
          }
        }
      },
      noDataImgUrl: require("../../../../../assets/images/other_icon/empty.png"),
      newsData: []
    };
  },
  created() {
    if(document.documentElement.clientWidth < 768) this.isMyDate = true
    else this.isMyDate = false
    if (this.$route.query.time) {
      const quarter = this.$route.query.time.split("-")[1].slice(0, -1);
      if (quarter === " Q") {
        this.$message({
          type: "warning",
          message: "This operation is not supported !"
        });
      }
    }

    const dataForm = /^(\d{4})-(\d{2})-(\d{2})$/;
    if (dataForm.test(this.$route.query.time)) {
      this.startDate = this.$route.query.time;
      this.endDate = this.$route.query.time;
    } else {
      if (this.$route.query.time === undefined) {
        this.startDate = null;
        this.endDate = null;
      } else {
        var date = new Date(this.$route.query.time);
        var nowYear = date.getFullYear();
        var nowMonth = date.getMonth();
        //本月的开始时间
        var monthStartDate = new Date(nowYear, nowMonth, 1);
        //本月的结束时间
        var monthEndDate = new Date(nowYear, nowMonth + 1, 0);
        const start = new Date(monthStartDate);
        const startDate =
          start.getFullYear() +
          "-" +
          (start.getMonth() + 1).toString().padStart(2, "0") +
          "-" +
          start
            .getDate()
            .toString()
            .padStart(2, "0");
        const end = new Date(monthEndDate);
        const endDate =
          end.getFullYear() +
          "-" +
          (end.getMonth() + 1).toString().padStart(2, "0") +
          "-" +
          end
            .getDate()
            .toString()
            .padStart(2, "0");
        this.startDate = startDate;
        this.endDate = endDate;
      }
    }
    this.startSearch();
    this.getNewsid();
  },
  computed: {
    noMore() {
      return this.currentPage >= this.totalPage - 1;
    },
    disabled() {
      return this.loading || this.noMore;
    }
  },
  methods: {
    load() {
      //滑到底部时进行加载   调用接口

      if (!this.loading) {
        this.loading = true;
        //this.scrollDiv = true;
        this.currentPage += 1;
        this.startSearch();
      }
    },
    defaultImg(item) {
      item.cover = this.companyIfor[0].logoPath;
    },
    querySearch(queryString, cb) {
      var restaurants = this.restaurants;
      var results = queryString
        ? restaurants.filter(this.createFilter(queryString))
        : restaurants;
      // 调用 callback 返回建议列表的数据
      cb(results);
    },
    createFilter(queryString) {
      return restaurant => {
        return (
          restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) ===
          0
        );
      };
    },
    // 顶部搜索
    search() {
      this.entryKeyword = true;
      this.currentPage = 1;
      this.searchVal = "";
      this.startSearch();
    },
    // 新闻来源搜索
    handleSelect(item) {
      this.newsVal = item;
      this.currentPage = 1;
      this.startSearch();
    },
    getStartDate() {
      this.entryStart = true;
      this.currentPage = 1;
      this.startSearch();
    },
    getEndDate() {
      this.entryEnd = true;
      this.currentPage = 1;
      this.startSearch();
    },
    async getNewsid() {
      let res = await newsID({ companyId: this.$route.query.id });
      this.options = res.result;
    },
    // 新闻详情
    newContentDetail(id) {
      this.$router.push({
        name: "ArticleDetails",
        query: {
          id: id
        }
      });
    },
    async startSearch() {
      if(this.startDate == null || this.startDate == 'Invalid date') this.startDate = "";
      if(this.endDate == null || this.endDate == 'Invalid date') this.endDate = "";
      let data = {
        companyId: this.companyID, //新闻所属企业ID
        currentPage: this.currentPage, //当前页
        pageSize: this.pageSize, //每页条数
        keyWords: this.searchVal, //搜索关键词
        sourceId: this.newsVal, //新闻来源ID
        startTime: this.startDate, //开始时间
        endTime: this.endDate, //
        brandToken: localStorage.getItem("brand-token")
      };
      let res = await overseasPublic(qs.stringify(data));
      this.loading = false;
      if (this.currentPage == 1) {
        this.newsData = res.result.list;
      } else {
        this.newsData = this.newsData.concat(res.result.list);
      }
      this.totalPage = res.result.totalPage;
      this.totalNum = res.result.totalElements;
    },
    startConfirm(startTime) {
      this.startDate = this.$moment(new Date(startTime)).format("YYYY-MM-DD");
      this.startSearch();
    },
    endConfirm(endTime) {
      this.endDate = this.$moment(new Date(endTime)).format("YYYY-MM-DD");
      this.startSearch();
    },
    startCancel() {
      this.startDate = "";
      this.startSearch();
    },
    endCancel() {
      this.endDate = "";
      this.startSearch();
    },
    startClear() {
      this.startDate = "";
      this.startSearch();
    },
    endClear() {
      this.endDate = "";
      this.startSearch();
    }
  },
  watch: {
    companyIfor: {
      handler(val) {
        this.companyIfor = val;
      },
      deep: true
    },
    endDate() {
      if (this.endDate == null) {
        this.currentPage = 1;
        this.startSearch();
      }
    },
    startDate() {
      if (this.startDate == null) {
        this.currentPage = 1;
        this.startSearch();
      }
    }
  }
};
</script>

<style scoped>
.lyric_search {
  position: relative;
}

.no_data {
  margin-top: 95px;
  text-align: center;
}

.no_data .no_data_txt {
  font-size: 14px;
  color: #4e5671;
  margin-top: 15px;
}

.no_data img {
  width: 200px;
}

.search {
  width: 100%;
  margin-top: 5px;
}

.search >>> .el-input-group__append .el-icon-search {
  font-size: 20px;
  font-weight: bold;
}

.search >>> .el-input-group__append {
  border: 0;
  background: transparent;
}

.search >>> .el-input__inner {
  border: 0;
  background: transparent;
}

.search >>> .input_style {
  border-radius: 40px;
  background: #f2f3f4;
  border: 1px solid #e2e3e4;
}

.othen_search {
  margin: 5px 0 0;
}

.othen_search > div {
  display: inline-block;
  margin-right: 24px;
}

.to_txt {
  font-size: 14px;
  color: #4e5671;
}

.date_search {
  margin-bottom: 10px;
}

.date_search >>> .el-input {
  width: 120px;
}

.date_search >>> .el-input__inner,
.date_search >>> .el-input__icon {
  height: 32px;
  line-height: 32px;
}

.item_title {
  display: inline-block;
  font-size: 12px;
  color: #4e5671;
  font-weight: bold;
  margin-right: 2px;
  font-family: RCB;
}

.news_source >>> .news_input {
  display: inline-block;
  width: 270px;
}

.news_source >>> .el-input__inner,
.news_source >>> .el-input__icon {
  height: 32px;
  line-height: 32px;
}

.news {
  height: 255px;
  border-bottom: 1px solid #f3f4f5;
}

.news > div {
  display: inline-block;
  vertical-align: top;
}

.news_img {
  width: 145px;
  margin: 30px 0 15px;
  text-align: center;
}

.news_content {
  padding-top: 27px;
  width: calc(100% - 145px);
}

.img_container {
  width: 120px;
  height: 78px;
  line-height: 73px;
  border: 1px solid #dee2e6;
  border-radius: 4px;
}

.img_container img {
  max-width: 100%;
}

.news .news_content .title {
  font-size: 16px;
  color: #9ca2b3;
  font-weight: bold;
  margin-bottom: 10px;
  cursor: pointer;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 4;
  -webkit-box-orient: vertical;
  font-family: RCB;
}

.news .news_content .title:hover {
  color: #4e5671;
}

.news .color_alone {
  color: #1a6bc5;
  font-family: RCR;
}
.item_detail {
  font-family: RCR;
}
.news .news_content .detail {
  font-size: 13px;
  color: #6c757d;
  line-height: 20px;
  margin-bottom: 15px;
  font-family: RCR;
}

.other_infor > div {
  display: inline-block;
  vertical-align: middle;
  font-size: 12px;
  color: #6c757d;
}

.data_list >>> .el-pagination {
  margin: 0 auto;
  text-align: center;
}
.news_source >>> .el-select > .el-input {
  width: 200px !important;
}
.date_search >>> .el-date-editor.el-input,
.el-date-editor.el-input__inner {
  width: 150px !important;
}
.date_search >>> .el-input--suffix .el-input__inner {
  padding-right: 20px !important;
}
.time >>> .el-date-editor.el-input,
.el-date-editor.el-input__inner {
  width: 125px !important;
}
.time >>> .el-input--suffix .el-input__inner {
  padding-right: 20px !important;
}
.time .date_item {
  margin-right: 0 !important;
  line-height: 32px !important;
  width: 90% !important;
  text-align: right !important;
}
@media screen and (max-width: 1024px) {
  .time .date_item {
    text-align: left !important;
  }
}
</style>